const COMMON_CONFIG = {
  S3_BUCKET_URL: 'https://images.opencare.com/',
  FUNNEL: true,
  MATCH_RESULTS_TIME_SLOTS_WIDGET: true,
  MATCH_RESULTS_TIME_SLOTS_WIDGET_STATES: '*',
  MATCH_RESULTS_TIME_SLOTS_WIDGET_LOCALITIES: '*',
};

const DEFAULT_CONFIG = {
  ENV: 'local',

  API_URL: 'https://localhost:1337',
  SEARCH_APP_URL: 'https://localhost:3004',
  SEARCH_APP_V2_URL: 'https://localhost:3015',
  PATIENT_APP_URL: 'https://localhost:3011',
  CLINIC_APP_URL: 'https://localhost:3007',
  CLINIC_APP_V4_URL: 'https://localhost:3014',
  IMAGES_URL: 'https://images-dev.opencare.com/',

  GOOGLE_MAPS_API_KEY: 'AIzaSyAhNi-MCo_lmZBLTF8lE64jN8f5Vjfvw3g',
  GOOGLE_ONE_TAP_CLIENT_ID: '862815043606-1dnp90ot7uck42hklokkga8s5h5mb4hl.apps.googleusercontent.com',
};

const CI_CONFIG = {
  ...DEFAULT_CONFIG,
  API_URL: 'https://api-staging.opencare.com',
};

const NGROK_CONFIG = {
  API_URL: 'https://ngrok-api.local.opencare.com',
  SEARCH_APP_URL: 'https://ngrok.local.opencare.com',
  SEARCH_APP_V2_URL: 'https://ngrok-v2.local.opencare.com',
  PATIENT_APP_URL: 'https://ngrok-patient.local.opencare.com',
  CLINIC_APP_URL: 'https://ngrok-clinic.local.opencare.com',
  CLINIC_APP_V4_URL: 'https://ngrok-clinic-v2.local.opencare.com',
  IMAGES_URL: 'https://images-dev.opencare.com/',

  GOOGLE_MAPS_API_KEY: 'AIzaSyAhNi-MCo_lmZBLTF8lE64jN8f5Vjfvw3g',
  GOOGLE_ONE_TAP_CLIENT_ID: '862815043606-1dnp90ot7uck42hklokkga8s5h5mb4hl.apps.googleusercontent.com',
};

const STAGING_CONFIG = {
  ENV: 'staging',

  API_URL: 'https://api-staging.opencare.com',
  SEARCH_APP_URL: 'https://staging.opencare.com',
  SEARCH_APP_V2_URL: 'https://search-staging.opencare.com',
  PATIENT_APP_URL: 'https://patient-staging.opencare.com',
  CLINIC_APP_URL: 'https://app-staging.opencare.com',
  CLINIC_APP_V4_URL: 'https://app-v2-staging.opencare.com',
  IMAGES_URL: 'https://images.opencare.com/',

  GOOGLE_MAPS_API_KEY: 'AIzaSyA6RdTdysqhEwXNGpBe_ugZuuw0arLYuLU',
  GOOGLE_ONE_TAP_CLIENT_ID: '862815043606-1dnp90ot7uck42hklokkga8s5h5mb4hl.apps.googleusercontent.com',
};

const DEMO_CONFIG = {
  ENV: 'demo',

  API_URL: 'https://api-demo.opencare.com',
  SEARCH_APP_URL: 'https://demo.opencare.com',
  SEARCH_APP_V2_URL: 'https://search-demo.opencare.com',
  PATIENT_APP_URL: 'https://patient-demo.opencare.com',
  CLINIC_APP_URL: 'https://app-demo.opencare.com',
  CLINIC_APP_V4_URL: 'https://app-v2-demo.opencare.com',
  IMAGES_URL: 'https://images.opencare.com/',

  GOOGLE_MAPS_API_KEY: 'AIzaSyA6RdTdysqhEwXNGpBe_ugZuuw0arLYuLU',
  GOOGLE_ONE_TAP_CLIENT_ID: '862815043606-1dnp90ot7uck42hklokkga8s5h5mb4hl.apps.googleusercontent.com',
};

const PRODUCTION_CONFIG = {
  ENV: 'production',

  API_URL: 'https://api.opencare.com',
  SEARCH_APP_URL: 'https://www.opencare.com',
  SEARCH_APP_V2_URL: 'https://search.opencare.com',
  PATIENT_APP_URL: 'https://patient.opencare.com',
  CLINIC_APP_URL: 'https://app.opencare.com',
  CLINIC_APP_V4_URL: 'https://app-v2.opencare.com',
  IMAGES_URL: 'https://images.opencare.com/',

  GOOGLE_MAPS_API_KEY: 'AIzaSyA6RdTdysqhEwXNGpBe_ugZuuw0arLYuLU',
  GOOGLE_ONE_TAP_CLIENT_ID: '862815043606-1dnp90ot7uck42hklokkga8s5h5mb4hl.apps.googleusercontent.com',
};

const configForEnvironment = (() => {
  if (process.env.ENABLE_TUNNEL) {
    return NGROK_CONFIG;
  }

  // Development, test environments
  if (process.env.NODE_ENV !== 'production') {
    if (process.env.CI === 'true') {
      return CI_CONFIG;
    }

    return DEFAULT_CONFIG;
  }

  if (process.env.ENV_STAGING === 'true') {
    return STAGING_CONFIG;
  }

  if (process.env.ENV_DEMO === 'true') {
    return DEMO_CONFIG;
  }

  return PRODUCTION_CONFIG;
})();

const config = {
  ...COMMON_CONFIG,
  ...configForEnvironment,
};

module.exports = config;
